<button [type]="type" (click)="back()" mat-icon-button aria-label="Example icon button with a vertical three dot icon">
  <mat-icon class="material-icons-outlined default-color">arrow_left</mat-icon>
</button>
